import * as chatApi from '@/api/chat'
import { getToken } from '@/utils/auth'
import { getUnreadCount } from '@/api/chat'

const chat = {
  state: {
    conversations: [],
    currentConversation: null,
    messages: [],
    unreadCount: 0,
    lastCheckTime: null,
    pollingTimer: null,
    hasNewMessage: false,
    latestMessage: null
  },

  mutations: {
    SET_CONVERSATIONS: (state, conversations) => {
      state.conversations = conversations
    },
    SET_CURRENT_CONVERSATION: (state, conversation) => {
      state.currentConversation = conversation
    },
    SET_MESSAGES: (state, messages) => {
      state.messages = messages
    },
    ADD_MESSAGE: (state, message) => {
      state.messages.push(message)
    },
    SET_UNREAD_COUNT: (state, count) => {
      state.unreadCount = count
    },
    SET_LAST_CHECK_TIME: (state, time) => {
      state.lastCheckTime = time
    },
    SET_POLLING_TIMER: (state, timer) => {
      state.pollingTimer = timer
    },
    SET_HAS_NEW_MESSAGE: (state, hasNew) => {
      state.hasNewMessage = hasNew
    },
    SET_LATEST_MESSAGE: (state, message) => {
      state.latestMessage = message
    },
    CLEAR_CHAT_STATE: (state) => {
      state.conversations = []
      state.currentConversation = null
      state.messages = []
      state.unreadCount = 0
      state.hasNewMessage = false
      state.latestMessage = null
    }
  },

  actions: {
    // 获取会话列表
    GetConversations({ commit }) {
      return new Promise((resolve, reject) => {
        chatApi.getConversations().then(res => {
          if (res.code === 20000) {
            commit('SET_CONVERSATIONS', res.data || [])
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取消息历史
    GetMessages({ commit }, conversationId) {
      return new Promise((resolve, reject) => {
        chatApi.getMessages(conversationId).then(res => {
          if (res.code === 20000) {
            commit('SET_MESSAGES', res.data || [])
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 发送消息
    SendMessage({ commit }, data) {
      return new Promise((resolve, reject) => {
        chatApi.sendMessage(data).then(res => {
          if (res.code === 20000) {
            commit('ADD_MESSAGE', res.data)
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 创建会话（会员联系红娘）
    CreateConversation({ commit }, data) {
      return new Promise((resolve, reject) => {
        chatApi.createConversation(data).then(res => {
          if (res.code === 20000) {
            commit('SET_CURRENT_CONVERSATION', res.data)
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 标记已读
    MarkAsRead({ commit, state }, conversationId) {
      return new Promise((resolve, reject) => {
        chatApi.markAsRead({ conversationId }).then(res => {
          if (res.code === 20000) {
            if (state.currentConversation && state.currentConversation.id === conversationId) {
              commit('SET_CURRENT_CONVERSATION', {
                ...state.currentConversation,
                unreadCount: 0
              })
            }
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取未读数
    GetUnreadCount({ commit }) {
      return new Promise((resolve, reject) => {
        chatApi.getUnreadCount().then(res => {
          if (res.code === 20000) {
            commit('SET_UNREAD_COUNT', res.data || 0)
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 检查新消息（轮询）
    CheckNewMessages({ commit, state }) {
      return new Promise((resolve, reject) => {
        chatApi.checkNewMessages().then(res => {
          if (res.code === 20000) {
            commit('SET_LAST_CHECK_TIME', new Date())
            if (res.data && res.data.hasNewMessages) {
              commit('SET_HAS_NEW_MESSAGE', true)
              commit('SET_LATEST_MESSAGE', res.data)
            }
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 设置当前会话
    SetCurrentConversation({ commit }, conversation) {
      commit('SET_CURRENT_CONVERSATION', conversation)
    },

    // 清除聊天状态
    ClearChatState({ commit }) {
      commit('CLEAR_CHAT_STATE')
    },

    // 启动轮询
    StartPolling({ dispatch, commit, state }) {
      // 如果已经有定时器在运行，先清除
      if (state.pollingTimer) {
        clearInterval(state.pollingTimer)
      }

      // 每30秒检查一次新消息
      const timer = setInterval(() => {
        dispatch('CheckNewMessages')
      }, 30000)

      commit('SET_POLLING_TIMER', timer)
    },

    // 停止轮询
    StopPolling({ commit, state }) {
      if (state.pollingTimer) {
        clearInterval(state.pollingTimer)
        commit('SET_POLLING_TIMER', null)
      }
    },

    // 清除新消息标记
    ClearNewMessageFlag({ commit }) {
      commit('SET_HAS_NEW_MESSAGE', false)
      commit('SET_LATEST_MESSAGE', null)
    }
  },

  getters: {
    conversations: state => state.conversations,
    currentConversation: state => state.currentConversation,
    messages: state => state.messages,
    unreadCount: state => state.unreadCount,
    hasNewMessage: state => state.hasNewMessage,
    latestMessage: state => state.latestMessage
  }
}

export default chat


// WEBPACK FOOTER //
// ./src/store/modules/chat.js